import React, { useEffect, useState } from "react";

// impotation style for loading
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// importation router
import { NavLink } from "react-router-dom";

// importation style
import "./style.css";

export default function Products() {
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(data);
    const [loading, setLoading] = useState(false);

    let componentMounted = true;

    useEffect(() => {
        const getProducts = async () => {
            setLoading(true);

            const responce = await fetch("https://fakestoreapi.com/products");

            if (componentMounted) {
                setData(await responce.clone().json());
                setFilter(await responce.json());
                setLoading(false);
            }

            return () => {
                componentMounted = true;
            };
        };

        getProducts();
    }, []);

    const Loading = () => {
        return (
            <div>
                <div className=" loading flex justify-center pt-10 ">
                    <Skeleton className="mx-3" width={100} height={20} />
                    <Skeleton className="mx-3" width={100} height={20} />
                    <Skeleton className="mx-3" width={100} height={20} />
                    <Skeleton className="mx-3" width={100} height={20} />
                    <Skeleton className="mx-3" width={100} height={20} />
                </div>
                <div className=" loading flex flex-wrap justify-around pt-10 ">
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                    <Skeleton className="mx-3 mb-2" width={189} height={200} />
                </div>
            </div>
        );
    };

    // filter category for products
    const filterProduct = (cart) => {
        const udateList = data.filter((product) => product.category === cart);
        setFilter(udateList);
    };

    const SowProducts = () => {
        return (
            <div>
                <ul className="buttons mt-16 md:flex justify-center grid ">
                    <button
                        exact={true}
                        to="/all"
                        className="mx-2 p-2 capitalize "
                        onClick={() => setFilter(data)}
                    >
                        all
                    </button>
                    <button
                        to="/men's clothing"
                        className="mx-2 p-2 capitalize  text-xs "
                        onClick={() => filterProduct("men's clothing")}
                    >
                        men's clothing
                    </button>
                    <button
                        className="mx-2 p-2 capitalize"
                        onClick={() => filterProduct("women's clothing")}
                    >
                        women's clothing
                    </button>
                    <button
                        className="mx-2 p-2 capitalize"
                        onClick={() => filterProduct("jewelery")}
                    >
                        jewelery
                    </button>
                    <button
                        className="mx-2 p-2 capitalize"
                        onClick={() => filterProduct("electronics")}
                    >
                        electronic
                    </button>
                </ul>

                <div className="containeer mx-auto w-11/12 md:grid lg:grid-cols-5 md:grid-cols-4 flex justify-center gap-6 flex-wrap mt-32">
                    {filter.map((prodct, key) => {
                        return (
                            <div
                                className="products relative w-52 text-center p-7 mx-3 mb-3  sm:mx-1"
                                key={key}
                            >
                                <div className="image">
                                    <img
                                        src={prodct.image}
                                        alt={prodct.title}
                                    />
                                </div>
                                <div className="absolute left-10 bottom-16 ">
                                    <h2 className="font-bold">
                                        {prodct.title.substring(0, 12)}...
                                    </h2>
                                    <span className="font-bold">
                                        {" "}
                                        $ {prodct.price}
                                    </span>
                                </div>
                                <NavLink
                                    to={`/producs/${prodct.id}`}
                                    className=" btn p-2 capitalize absolute left-14 bottom-4 "
                                >
                                    buy now
                                </NavLink>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className="containeer mx-auto w-11/12 py-20 ">
            <h1 className=" text-center text-5xl font-bold capitalize mb-5">
                Latest products
            </h1>
            <hr />
            <div>{loading ? <Loading /> : <SowProducts />}</div>
        </div>
    );
}
